import { render, staticRenderFns } from "./chp-tab.vue?vue&type=template&id=57265ea2"
import script from "./chp-tab.ts?vue&type=script&lang=js&external"
export * from "./chp-tab.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57265ea2')) {
      api.createRecord('57265ea2', component.options)
    } else {
      api.reload('57265ea2', component.options)
    }
    module.hot.accept("./chp-tab.vue?vue&type=template&id=57265ea2", function () {
      api.rerender('57265ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/tabs/chp-tab/chp-tab.vue"
export default component.exports